export default "\nconsole.log(\"preserve_newlines1\");\n\n\n\nconsole.log(\"preserve_newlines2\");\n\n\nconsole.log(\"preserve_newlines3\");\n\n"